<mat-icon *ngIf="icon" [svgIcon]="icon" [ngClass]="size" [title]="'PLANTTYPES.' + icon | translate"></mat-icon>
<span *ngIf="hasText">{{'PLANTTYPES.' + icon | translate}}</span>
